import style from 'containers/MyHealth/components/MyHealthResultsContext/styles'
import { FONT_FAMILY } from 'styles/typography'
const themeStyles = colors => {
  const styles = {
    ...style(colors),
    testContainer: (isMobile) => {
      return {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: isMobile ? 'column' : 'row'
      }
    },
    text: {
      flexBasis: 'auto',
      margin: 0
    },
    leftContainer: {
      display: 'flex',
      flex: 0.8,
      justifyContent: 'space-between'
    },
    buttonContainer: (isMobile) => {
      return {
        display: 'flex',
        flex: 0.2,
        justifyContent: isMobile ? 'space-between' : 'end',
        alignItems: 'center',
        marginTop: isMobile ? '10px' : '0'
      }
    },
    buttonDownload: {
      button: {
        fontFamily: FONT_FAMILY,
        display: 'flex',
        minWidth: 166,
        width: 'fit-content',
        padding: '1px 16px',
        height: '32px',
        fontWeight: 400,
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 13,
        background: colors.primary,
        color: colors.white,
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '17.5px',
        letterSpacing: 0.7,
        textTransform: 'uppercase',
        marginRight: 20
      }
    },
    buttonIcon: {
      width: 13,
      height: 13,
      marginRight: 10,
      fill: colors.white
    },
    hide: {
      display: 'none'
    },
    link: {
      flexBasis: 'auto',
      flex: 1,
      margin: '0 40px 0 0'
    },
    linkText: {
      color: colors.colorPrimary,
      textDecoration: 'underline',
      fontSize: 14
    }
  }
  styles.textLeft = { ...styles.text, flex: 1 }
  return styles
}

export default themeStyles
